import React, { memo } from 'react';
import TEMPLATE_COMPONENTS_BY_NAME from 'components/Generic/Forms/SalesforceIntegratedForms/fieldsTemplates/fieldsMapping';
import { FieldsType } from 'model/SalesforceField';
import useSalesforceSharedLogic from 'hooks/useSalesforceSharedLogic';

type FieldTypeDefinerProps = {
  templateName: string;
  sectionName: string;
  stepName: string;
  fields: FieldsType;
  displaySection?: boolean;
  nestedField?: boolean;
  className?: string;
  parentComponentName?: string;
};

const EMPTY_COMPONENT = () => {};

const RepeatableSectionFieldDefiner = memo(function RepeatableSectionFieldDefiner({
  templateName,
  nestedField = false,
  stepName,
  sectionName,
  displaySection = true,
  fields,
  className,
  parentComponentName,
}: FieldTypeDefinerProps) {
  const Component = TEMPLATE_COMPONENTS_BY_NAME[templateName] ?? EMPTY_COMPONENT;
  const { haveNestedFields, formData, valueSelected, showSection, addBorder } =
    useSalesforceSharedLogic({ fields, stepName, parentComponentName });

  return (
    <div className={className}>
      <Component
        fields={fields}
        sectionName={sectionName}
        stepName={stepName}
        nestedField={nestedField}
        formData={formData}
        onValueSelected={valueSelected}
      />

      {haveNestedFields &&
        displaySection &&
        fields.items.map((nestedField, index) => (
          <RepeatableSectionFieldDefiner
            key={index}
            templateName={nestedField.template}
            sectionName={nestedField.displayName}
            className={addBorder ? 'nested-section' : ''}
            parentComponentName="FieldTypeDefiner"
            stepName={stepName}
            fields={nestedField.fields}
            displaySection={showSection(nestedField)}
            nestedField={true}
          />
        ))}
    </div>
  );
});

export default RepeatableSectionFieldDefiner;
